import InputOnlyNumber from "./InputOnlyNumber";

export default InputOnlyNumber;
